import { render, staticRenderFns } from "./featuredPlaceholder.vue?vue&type=template&id=791b12d4&scoped=true"
import script from "./featuredPlaceholder.vue?vue&type=script&lang=js"
export * from "./featuredPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./featuredPlaceholder.vue?vue&type=style&index=0&id=791b12d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791b12d4",
  null
  
)

export default component.exports